import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  I18n,
  Link,
  Preloader,
  Status,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const PinPuk = ({
  fetchPinPuk,
  error,
  isLoading,
  isLoaded,
  pin,
  pin2,
  puk,
  puk2,
  url,
}) => {
  if (isLoading) {
    return (
      <Preloader
        className={cx('preloader')}
        size="30"
      />
    );
  }

  if (error) {
    return (
      <div className={cx('container')}>
        <I18n
          className={cx('gray')}
          path="settings.numberManagement.phoneNumberConfig.your"
        />
        &nbsp;
        <Link onClick={fetchPinPuk}>
          <I18n path="settings.numberManagement.phoneNumberConfig.pin" />
          &nbsp;
          <I18n path="common.and" />
          &nbsp;
          <I18n path="settings.numberManagement.phoneNumberConfig.puk" />
        </Link>
        &nbsp;
        <I18n
          className={cx('gray')}
          path="settings.numberManagement.phoneNumberConfig.accessCodes"
        />
        <Status
          className={['attention', cx('statusFail')]}
          emoji="statusFail"
        >
          <I18n
            className={cx('gray')}
            path="settings.numberManagement.phoneNumberConfig.notAvailable"
          />
          &nbsp;
          <Link onClick={fetchPinPuk}>
            <I18n path="settings.numberManagement.phoneNumberConfig.tryLater" />
          </Link>
        </Status>
      </div>
    );
  }

  if (isLoaded) {
    return (
      <div className={cx('container')}>
        <div className={cx('hint', 'gray')}>
          <I18n path="settings.numberManagement.phoneNumberConfig.hint" />
        </div>
        <div className={cx('pinPukWrapper')}>
          <div className={cx('pinPuk')}>
            <span className={cx('gray')}>
              <I18n path="settings.numberManagement.phoneNumberConfig.pin" />
              :
            </span>
            &nbsp;
            {pin}
          </div>
          <div className={cx('pinPuk')}>
            <span className={cx('gray')}>
              <I18n path="settings.numberManagement.phoneNumberConfig.puk" />
              :
            </span>
            &nbsp;
            {puk}
          </div>
          <div className={cx('pinPuk')}>
            <span className={cx('gray')}>
              <I18n path="settings.numberManagement.phoneNumberConfig.pin" />
              2:
            </span>
            &nbsp;
            {pin2}
          </div>
          <div className={cx('pinPuk')}>
            <span className={cx('gray')}>
              <I18n path="settings.numberManagement.phoneNumberConfig.puk" />
              2:
            </span>
            &nbsp;
            {puk2}
          </div>
        </div>
        <Link
          className={cx('helpLink')}
          href={url}
        >
          <I18n path="settings.numberManagement.phoneNumberConfig.howToUse" />
        </Link>
      </div>
    );
  }

  return (
    <div className={cx('container')}>
      <Link onClick={fetchPinPuk}>
        <I18n path="settings.numberManagement.phoneNumberConfig.pin" />
        &nbsp;
        <I18n path="common.and" />
        &nbsp;
        <I18n path="settings.numberManagement.phoneNumberConfig.puk" />
      </Link>
      &nbsp;
      <I18n
        className={cx('gray')}
        path="settings.numberManagement.phoneNumberConfig.codes"
      />
    </div>
  );
};

PinPuk.propTypes = {
  fetchPinPuk: PropTypes.func,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  isLoaded: PropTypes.bool,
  pin: PropTypes.string,
  pin2: PropTypes.string,
  puk: PropTypes.string,
  puk2: PropTypes.string,
  url: PropTypes.string,
};

export default PinPuk;
